import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from '../../../../components/AdminLayout/AdminLayout';
import DashboardMainContainer from '../../../../components/common/Containers/DashboardMainContainer';
import {
  AdminPageTitle,
  AdminPanelTitle,
  AdminSupportingText,
  AdminMetadataText,
  AdminStatusBadge,
  AdminFormSecondaryAction,
  AdminRowAction,
  ADMIN_TOOLBAR_CLASS,
  ADMIN_TABLE_CLASS,
} from '../../shared/adminUx';

// Demo blog data - will be replaced with WordPress API integration
const DEMO_BLOGS = [
  {
    id: 1,
    title: '10 Essential Plumbing Tips for Homeowners',
    excerpt: 'Learn the most important plumbing maintenance tips to keep your home safe and prevent costly repairs...',
    author: 'John Smith',
    category: 'Home Maintenance',
    publishedDate: '2024-01-15',
    status: 'published',
    views: 1250,
    comments: 23,
    featuredImage: 'https://picsum.photos/400/250?random=1',
  },
  {
    id: 2,
    title: 'Electrical Safety Guidelines for DIY Projects',
    excerpt: 'Important safety measures every homeowner should know before starting any electrical work...',
    author: 'Sarah Johnson',
    category: 'Electrical',
    publishedDate: '2024-01-12',
    status: 'published',
    views: 890,
    comments: 15,
    featuredImage: 'https://picsum.photos/400/250?random=2',
  },
  {
    id: 3,
    title: 'Landscaping Ideas for Small Spaces',
    excerpt: 'Transform your small outdoor space with these creative landscaping ideas and design tips...',
    author: 'Mike Williams',
    category: 'Landscaping',
    publishedDate: '2024-01-10',
    status: 'published',
    views: 2100,
    comments: 34,
    featuredImage: 'https://picsum.photos/400/250?random=3',
  },
  {
    id: 4,
    title: 'How to Choose the Right Paint Colors',
    excerpt: 'A comprehensive guide to selecting paint colors that complement your home\'s style and lighting...',
    author: 'Emily Davis',
    category: 'Painting',
    publishedDate: '2024-01-08',
    status: 'published',
    views: 1650,
    comments: 28,
    featuredImage: 'https://picsum.photos/400/250?random=4',
  },
  {
    id: 5,
    title: 'Kitchen Renovation Planning Guide',
    excerpt: 'Everything you need to know about planning and budgeting for your kitchen renovation project...',
    author: 'David Brown',
    category: 'Renovation',
    publishedDate: '2024-01-05',
    status: 'published',
    views: 980,
    comments: 12,
    featuredImage: 'https://picsum.photos/400/250?random=5',
  },
];

const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' });
};

const BlogPublished = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    // Simulate API call - will be replaced with WordPress API integration
    const fetchBlogs = async () => {
      setLoading(true);
      try {
        await new Promise(resolve => setTimeout(resolve, 500));
        setBlogs(DEMO_BLOGS);
      } catch (error) {
        console.error('Error fetching published blogs:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  const handleEdit = (blogId) => {
    // TODO: Navigate to edit page (will be implemented with WordPress integration)
    console.log('Edit blog:', blogId);
  };

  const handleView = (blogId) => {
    // TODO: Navigate to view page (will be implemented with WordPress integration)
    console.log('View blog:', blogId);
  };

  if (loading) {
    return (
      <AdminLayout>
        <DashboardMainContainer className={ADMIN_TABLE_CLASS}>
          <div className="flex items-center justify-center h-96">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primaryblue"></div>
          </div>
        </DashboardMainContainer>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div className="tp-container-main">
        <div>
        <AdminPageTitle>Published Articles</AdminPageTitle>
        <div className={ADMIN_TOOLBAR_CLASS}>
          <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4">
            <div className="flex-1" />
          </div>
        </div>

        {/* Blog List */}
        <DashboardMainContainer className={ADMIN_TABLE_CLASS}>
          {blogs.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-16">
              <AdminSupportingText className="text-mediumgray text-center mb-4">No published articles found</AdminSupportingText>
              <AdminSupportingText className="text-mediumgray text-center">
                Articles will appear here once they are published.
              </AdminSupportingText>
            </div>
          ) : (
            <div className="space-y-4">
              {blogs.map((blog) => (
                <div
                  key={blog.id}
                  className="border border-lightgray rounded-lg p-4 hover:border-primaryblue transition-colors"
                >
                  <div className="flex flex-col lg:flex-row gap-4">
                    {/* Featured Image */}
                    <div className="w-full lg:w-48 h-32 flex-shrink-0">
                      <img
                        src={blog.featuredImage}
                        alt={blog.title}
                        className="w-full h-full object-cover rounded-lg"
                      />
                    </div>

                    {/* Content */}
                    <div className="flex-1 flex flex-col justify-between">
                      <div>
                        <div className="flex items-start justify-between gap-4 mb-2">
                          <AdminPanelTitle className="text-offblack line-clamp-2">{blog.title}</AdminPanelTitle>
                          <AdminStatusBadge status="Published" label="Published" className="whitespace-nowrap" />
                        </div>
                        <AdminSupportingText className="text-mediumgray mb-3 line-clamp-2 block">
                          {blog.excerpt}
                        </AdminSupportingText>
                        <div className="flex flex-wrap items-center gap-4">
                          <AdminMetadataText className="text-mediumgray">By {blog.author}</AdminMetadataText>
                          <AdminMetadataText className="text-mediumgray">•</AdminMetadataText>
                          <AdminMetadataText className="text-mediumgray">{blog.category}</AdminMetadataText>
                          <AdminMetadataText className="text-mediumgray">•</AdminMetadataText>
                          <AdminMetadataText className="text-mediumgray">{formatDate(blog.publishedDate)}</AdminMetadataText>
                          <AdminMetadataText className="text-mediumgray">•</AdminMetadataText>
                          <AdminMetadataText className="text-mediumgray">{blog.views} views</AdminMetadataText>
                          <AdminMetadataText className="text-mediumgray">•</AdminMetadataText>
                          <AdminMetadataText className="text-mediumgray">{blog.comments} comments</AdminMetadataText>
                        </div>
                      </div>

                      {/* Actions */}
                      <div className="flex gap-2 mt-4">
                        <AdminRowAction onClick={() => handleView(blog.id)}>
                          View
                        </AdminRowAction>
                        <AdminFormSecondaryAction type="button" onClick={() => handleEdit(blog.id)}>
                          Edit
                        </AdminFormSecondaryAction>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </DashboardMainContainer>
        </div>
      </div>
    </AdminLayout>
  );
};

export default BlogPublished;

